import { Separator } from '@playbooks/ui/components/separator';

const AuthDivider = ({ children = 'or' }) => {
	// Render
	return (
		<div className='flex-middle gap-3 py-1 text-xs text-foreground-subtle'>
			<Separator />
			<span className='shrink-0'>{children}</span>
			<Separator />
		</div>
	);
};

export { AuthDivider };
